export default __webpack_public_path__ + "static/media/user-placeholder.20f113d3.jpg";